import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const mapStateToProps = state => {
    return {
        mediaType: state.appSettings.mediaType
    }
}

class BannerFullWidth extends React.Component {
    render() {
        var { content } = this.props;
        var desktopSize = {
            width: null,
            height: null
        };

        var backgroundImage = content.image.mediaItemUrl;
        if (this.props.mediaType === "desktop" && content.imageDesktop !== null) {
            backgroundImage = content.imageDesktop.mediaItemUrl;

            if (content.imageDesktop.mediaDetails.width > 0 
                && content.imageDesktop.mediaDetails.height > 0) {
                    desktopSize.width = "100%";
                    desktopSize.height = (content.imageDesktop.mediaDetails.height / content.imageDesktop.mediaDetails.width) * 100 + "vw";
            }
        }

        return <Link className="banner-full-width" style={{
            backgroundImage: "url(" + backgroundImage + ")",
            width: desktopSize.width,
            height: desktopSize.height
        }} to={content.href.url}>
            <span className="title">{content.title}</span>
            {content.subtitle && <span className="subtitle">{content.subtitle}</span>}
            
            {content.ctatext && <div className="separator"></div>}
            {content.ctatext && <span className="cta-btn">{content.ctatext}</span>}
        </Link>;
    }
}

export default connect(mapStateToProps)(BannerFullWidth);